import style from './ProviderList.module.scss';
import { FC, useCallback, useState } from 'react';
import { Icon, Icons } from '@silverfort/sf-components';
import ProviderItem from './ProviderItem';
import { IntegrationData } from './Types';
import { ON_PREM_PROVIDER_TO_TAB } from './Consts';
import { useHistory } from 'react-router-dom';

interface ProviderListProps {
    integration: IntegrationData;
}

const ProviderList: FC<ProviderListProps> = ({ integration }) => {
    const [open, setOpen] = useState(true);
    const history = useHistory();

    const sortedProviders = Object.values(integration.providers);
    sortedProviders.sort((a, b) => {
        if (a.active && !b.active) return -1;
        if (b.active && !a.active) return 1;
        return a.name.localeCompare(b.name);
    });

    const onAdd = useCallback(
        (providerName?: string) => {
            let targetUrl = integration.addUrl;

            if (
                integration.addUrl === '/Settings/Integrations' &&
                providerName &&
                ON_PREM_PROVIDER_TO_TAB[providerName]
            ) {
                targetUrl = ON_PREM_PROVIDER_TO_TAB[providerName];
            }

            history.push(targetUrl);
        },
        [integration.addUrl, history]
    );

    return (
        <div
            className={`flex flex-col pb-2 ${
                open
                    ? 'min-h-20 [&:has(>_div>_*:nth-child(2))]:min-h-28 [@container(min-height:600px)]:[&:has(>_div>_*:nth-child(3)):not(:has(>_div>_*:nth-child(4)))]:min-h-36 [@container(min-height:600px)]:[&:has(>_div>_*:nth-child(4))]:min-h-44'
                    : 'min-h-10'
            } `}>
            <button
                onClick={() => setOpen(!open)}
                className="flex items-center justify-between h-8 min-h-8 w-full text-sf-white font-normal text-12 font-sf border-b border-[#413D3B]">
                <span>
                    {integration.category} ({sortedProviders.length})
                </span>
                <Icon icon={open ? Icons.ChevronUp : Icons.ChevronDown} size={12} />
            </button>

            {open && (
                <div
                    className={`mt-2 pr-2 overflow-hidden hover:overflow-y-auto min-h-0 ${style.providerListScrollbar}`}>
                    {sortedProviders.map((provider, idx) => (
                        <ProviderItem key={idx} provider={provider} onAdd={() => onAdd(provider.name)} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProviderList;
